// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul[data-v-0bbfaff2]{font-size:12px!important}span[data-v-0bbfaff2],ul[data-v-0bbfaff2]{color:#c9d6df!important}span[data-v-0bbfaff2]{font-size:14px!important}hr[data-v-0bbfaff2]{color:#323234!important}", ""]);
// Exports
module.exports = exports;
